module.exports = __webpack_public_path__ + "static/media/background.2e1ff225.png";